export const getActiveEventKeyFromState = (
  eventId: { externalEventId: string; calendarId: string } | null,
) => {
  if (!eventId) return null;
  return eventId;
};
